import React from 'react';
import { Collapse, Icon } from 'antd';

import styles from './Faq.module.scss';
import { Helmet } from '../../common/components';

const { Panel } = Collapse;

const text = `
  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.
`;

const Faq = () => {
  return (
    <div className={styles.root}>
      <Helmet title={'S.S.S'} />
      <div className={styles.wrapper}>
        <h1>Sıkça Sorulan Sorular</h1>
        <Collapse
          expandIconPosition="right"
          bordered={false}
          defaultActiveKey={['1']}
          expandIcon={({ isActive }) => <Icon type="down" rotate={isActive ? 180 : 0} />}
        >
          <Panel header="This is panel header 1" key="1">
            <p>{text}</p>
          </Panel>
          <Panel header="This is panel header 2" key="2">
            <p>{text}</p>
          </Panel>
          <Panel header="This is panel header 3" key="3">
            <p>{text}</p>
          </Panel>
        </Collapse>
      </div>
    </div>
  );
};

export default Faq;
